import { Epic } from 'redux-observable'
import { tag } from 'rxjs-spy/operators/tag'
import { filter, map, mergeMap, pluck } from 'rxjs/operators'
import { isOfType } from 'typesafe-actions'
import { EpicDependencies, RootState } from 'src/state/types'
import { ENDPOINTS } from './constants'
import { BankingEvent, events } from './state'

export const apiFetchPartyErrorsById: Epic<BankingEvent, BankingEvent, RootState, EpicDependencies> = (
  action$,
  state$,
  { get, catchRestError },
) =>
  action$.pipe(
    filter(isOfType(events.partyErrors_request.type)),
    mergeMap(action =>
      get(ENDPOINTS.FETCH_PARTY_ERRORS, state$, action.payload).pipe(
        pluck('response'),
        map(response => events.partyErrors_success({ response, params: action.payload })),
        catchRestError(action),
      ),
    ),
    tag('banking/epics/apiFetchPartyErrorsById'),
  )

export const apiFetchPartiesErrorsByIds: Epic<BankingEvent, BankingEvent, RootState, EpicDependencies> = (
  action$,
  state$,
  { get, catchRestError },
) =>
  action$.pipe(
    filter(isOfType(events.partiesErrors_request.type)),
    mergeMap(action =>
      get(ENDPOINTS.FETCH_PARTIES_ERRORS, state$, action.payload).pipe(
        pluck('response'),
        map(response => events.partiesErrors_success({ response, params: action.payload })),
        catchRestError(action),
      ),
    ),
    tag('banking/epics/apiFetchPartiesErrorsByIds'),
  )
